import { createReducer } from '@reduxjs/toolkit';

import {
  IPharmacyRating,
  IPharmacyRatings,
  IProfessionalBookedRatingDetails,
  IProfessionalInvoiceResponse,
  IProfessionalRate,
} from '../models/ProfessionalModels';
import {
  generateProfessionalInvoice,
  getPharmacyBookedRating,
  getPharmacyRating,
  getPharmacyRatingItems,
  getProfessionalInvoice,
  resetProfessionalValue,
} from '../actions';

export interface IProfessionalState {
  ratingItems: IPharmacyRatings;
  rate: IProfessionalRate;
  rating: IPharmacyRating;
  bookedRating: IProfessionalBookedRatingDetails;
  invoiceDetails: IProfessionalInvoiceResponse;
  professionalInvoice: { pdfContent: string };
}

const initialState: IProfessionalState = {
  professionalInvoice: {
    pdfContent: '',
  },
  invoiceDetails: {
    date: '',
    invoiceNumber: '',
    professionalName: '',
    professionalAddress: '',
    professionalCity: '',
    professionalPostalCode: '',
    professionalProvince: '',
    professionalPhone: '',
    clientAddress: '',
    clientCity: '',
    clientPostalCode: '',
    clientProvince: '',
    tps: '',
    tvq: '',
    taxOnTax: false,
    bookings: [],
    institutionNumber: '',
    branchNumber: '',
    accountNumber: '',
    clientName: ''
  },
  ratingItems: {
    favorite: false,
    displayDetailForm: false,
    pharmacyRatingItems: [],
    pharmacyRatingQuestions: [],
  },
  rate: {
    bookingId: '',
    levels: [],
    favorite: false,
  },
  rating: {
    isFavorite: false,
    name: '',
    pharmacyId: '',
    reviews: 0,
    totalRating: '',
    ratings: [],
  },
  bookedRating: {
    data: {
      pharmacyRatings: [],
      pharmacyRatingAnswers: [],
    },
    comment: '',
    firstName: '',
    lastName: '',
    pharmacyId: '',
    isFavorite: false,
  },
};

const professionalReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(getPharmacyRatingItems.fulfilled, (state, action) => {
      state.ratingItems = action.payload;
    })
    .addCase(getPharmacyRating.fulfilled, (state, action) => {
      state.rating = action.payload;
    })
    .addCase(getProfessionalInvoice.fulfilled, (state, action) => {
      state.invoiceDetails = action.payload;
    })
    .addCase(generateProfessionalInvoice.fulfilled, (state, action) => {
      state.professionalInvoice = action.payload;
    })
    .addCase(resetProfessionalValue, (state, action) => {
      action.payload.map((item) => {
        // @ts-expect-error: REDUCERS HAVE WRITABLE INNATE TYPE
        state[item] = initialState[item as keyof typeof initialState];
      });
    })
    .addCase(getPharmacyBookedRating.fulfilled, (state, action) => {
      state.bookedRating = action.payload;
    });
});

export default professionalReducer;
